import { API_CLOSE_STICKY_BANNER } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";

export const useCloseStickyBannerMutation = () => useMutation(API_CLOSE_STICKY_BANNER);
